class InfinitySlider extends HTMLElement {

  static tagName = 'infinity-slider';

  static selectors = {
    container: '.custom-marquee-slider--container',
    child: '.custom-marquee-slider--child',
    image: 'img',
  };

  static cssVariables = {
    animationDuration: '--custom-marquee-slider--animation-duration',
    maxHeight: '--custom-marquee-slider--max-height',
    imageWidth: '--custom-marquee-slider--image-width',
    aspectRatio: '--custom-marquee-slider--aspect-ratio',
  };
  
  static modifiers = {
    loaded: 'loaded'
  }

  constructor() {
    super();

    this.animationDiration = this.getAttribute('animation-duration');
    this.maxHeight = this.getAttribute('max-height');
    this.imageWidth = this.getAttribute('image-width');
    this.aspectRatio = this.getAttribute('aspect-ratio');

    this.marqueeContainers = this.querySelectorAll( InfinitySlider.selectors.container );
    this.marqueeChildren = this.querySelectorAll( InfinitySlider.selectors.child );
    
    this.marqueeContainers.forEach( container => container.classList.add( InfinitySlider.modifiers.loaded ) );
    
    this.addStyle();
    this.updateMaxHeight();
    this.setAnimationDuration();

    window.addEventListener( 'resize', this, false );

  }

  handleEvent( event ) {
    switch ( event.type ) {
      case 'resize':
        this.updateMaxHeight();
        this.setAnimationDuration();
        break;
    }
  }

  addStyle() {
    const style = document.createElement( 'style' );

    style.textContent = `
      :root {
        ${InfinitySlider.cssVariables.animationDuration}: ${this.animationDiration}s;
        ${InfinitySlider.cssVariables.maxHeight}: ${this.maxHeight};
        ${InfinitySlider.cssVariables.imageWidth}: ${this.imageWidth};
        ${InfinitySlider.cssVariables.aspectRatio}: ${this.aspectRatio};
      }`;
    this.append( style );
  }

  setAnimationDuration() {
    this.marqueeContainers.forEach( container => {
      const viewportWidth = container.clientWidth;
      const animationDuration = `${ Math.max( 15, viewportWidth / 50 ) }s`;
      container.style.setProperty( InfinitySlider.cssVariables.animationDuration, animationDuration );
    } );
  }

  updateMaxHeight() {
    const maxHeight = parseInt( getComputedStyle( document.documentElement ).getPropertyValue( InfinitySlider.cssVariables.maxHeight ), 10 );
    const gcd = ( a, b ) => (b ? gcd( b, a % b ) : a);

    this.marqueeChildren.forEach( child => {
      const img = child.querySelector( InfinitySlider.selectors.image );
      if (img !== null) {
        img.addEventListener('load', () => {
          img.classList.add(InfinitySlider.modifiers.loaded);
          const imageWidth = `${Math.ceil(maxHeight * (img.naturalWidth / img.naturalHeight))}px`;
          const ratio = gcd(img.naturalWidth, img.naturalHeight);
          const aspectRatio = `${Math.floor(img.naturalWidth / ratio)}/${Math.floor(img.naturalHeight / ratio)}`;

          wrapper.style.setProperty(InfinitySlider.cssVariables.imageWidth, imageWidth);
          wrapper.style.setProperty(InfinitySlider.cssVariables.aspectRatio, aspectRatio);
        });
        if (img.complete) {
          img.dispatchEvent(new Event('load'));
        }
      }
    } );
  }
}

document.addEventListener( 'DOMContentLoaded', () => {
  customElements.define( InfinitySlider.tagName, InfinitySlider );
} );